export enum TaxonomyTypeEnum {
  WholeReportDocument,
  IncomeStatement,
  BalanceSheet,
  CashFlowStatement,
  PeriodKpis,
  SnapshotKpis,
}
